export const optionModifiersList = [
  'floating',
  'floating-with-arrow',
  'radio',
  'checkbox',
  'sky-it-square',
  'sky-it-card',
  'has-image',
  'not-clickable',
];
export const tagList = ['button', 'a'];
